
// Start midnight
jQuery(document).ready(function($) {
    $(".midnight").midnight();
})
